// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.instagram-connection {
    background: var(--card-bg, #fff);
    border-radius: 12px;
    padding: 24px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.instagram-connection.loading {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 200px;
    gap: 16px;
    color: var(--text-secondary, #666);
}

/* Section Header */
.instagram-connection .section-header {
    display: flex;
    align-items: flex-start;
    gap: 16px;
    margin-bottom: 24px;
}

.instagram-connection .header-icon {
    font-size: 2.5rem;
    line-height: 1;
}

.instagram-connection .header-text h2 {
    margin: 0 0 8px 0;
    font-size: 1.5rem;
    color: var(--text-primary, #1a1a1a);
}

.instagram-connection .header-text .description {
    margin: 0;
    color: var(--text-secondary, #666);
    font-size: 0.95rem;
}

/* Alerts */
.instagram-connection .alert {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 16px;
    border-radius: 8px;
    margin-bottom: 20px;
}

.instagram-connection .alert-success {
    background: #dcfce7;
    border: 1px solid #bbf7d0;
    color: #16a34a;
}

.instagram-connection .alert-error {
    background: #fef2f2;
    border: 1px solid #fecaca;
    color: #dc2626;
}

.instagram-connection .alert .dismiss {
    margin-left: auto;
    background: none;
    border: none;
    font-size: 1.2rem;
    cursor: pointer;
    color: inherit;
    opacity: 0.7;
}

.instagram-connection .alert .dismiss:hover {
    opacity: 1;
}

/* Connected Account */
.instagram-connection .account-card {
    border: 1px solid var(--border-color, #e5e7eb);
    border-radius: 12px;
    padding: 20px;
}

.instagram-connection .account-info {
    display: flex;
    align-items: flex-start;
    gap: 16px;
}

.instagram-connection .profile-picture {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    object-fit: cover;
    flex-shrink: 0;
}

.instagram-connection .profile-picture.placeholder {
    background: linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2rem;
}

.instagram-connection .account-details {
    flex: 1 1;
    min-width: 0;
}

.instagram-connection .account-details h3 {
    margin: 0 0 4px 0;
    font-size: 1.2rem;
    color: var(--text-primary, #1a1a1a);
}

.instagram-connection .account-details .display-name {
    margin: 0 0 8px 0;
    color: var(--text-secondary, #666);
}

.instagram-connection .account-details .stats {
    display: flex;
    gap: 16px;
    margin-bottom: 8px;
    font-size: 0.9rem;
}

.instagram-connection .account-details .stat {
    color: var(--text-secondary, #666);
}

.instagram-connection .account-details .stat strong {
    color: var(--text-primary, #1a1a1a);
}

.instagram-connection .account-details .connected-date,
.instagram-connection .account-details .last-post {
    margin: 0;
    font-size: 0.85rem;
    color: var(--text-tertiary, #888);
}

.instagram-connection .status-badge {
    padding: 6px 12px;
    border-radius: 20px;
    font-size: 0.85rem;
    font-weight: 500;
    flex-shrink: 0;
}

.instagram-connection .status-badge.active {
    background: #dcfce7;
    color: #16a34a;
}

.instagram-connection .status-badge.inactive {
    background: #fef3c7;
    color: #ca8a04;
}

.instagram-connection .token-warning {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px;
    background: #fef3c7;
    border-radius: 8px;
    margin-top: 16px;
    color: #92400e;
    font-size: 0.9rem;
}

.instagram-connection .account-actions {
    display: flex;
    gap: 12px;
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid var(--border-color, #e5e7eb);
}

/* No Account Connected */
.instagram-connection .no-account {
    text-align: center;
}

.instagram-connection .connect-prompt {
    padding: 40px 20px;
}

.instagram-connection .connect-prompt .icon {
    font-size: 4rem;
    margin-bottom: 16px;
    opacity: 0.8;
}

.instagram-connection .connect-prompt h3 {
    margin: 0 0 8px 0;
    color: var(--text-primary, #1a1a1a);
}

.instagram-connection .connect-prompt p {
    margin: 0 0 16px 0;
    color: var(--text-secondary, #666);
}

.instagram-connection .connect-prompt .requirements {
    text-align: left;
    display: inline-block;
    margin: 0;
    padding-left: 24px;
    color: var(--text-secondary, #666);
    font-size: 0.9rem;
}

.instagram-connection .connect-prompt .requirements li {
    margin-bottom: 8px;
}

/* Username Input */
.instagram-connection .username-input-group {
    max-width: 360px;
    margin: 0 auto 24px;
    text-align: left;
}

.instagram-connection .username-input-group label {
    display: block;
    font-weight: 600;
    margin-bottom: 8px;
    color: var(--text-primary, #1a1a1a);
    font-size: 0.95rem;
}

.instagram-connection .username-input-wrapper {
    display: flex;
    align-items: center;
    border: 2px solid var(--border-color, #d1d5db);
    border-radius: 8px;
    overflow: hidden;
    transition: border-color 0.2s;
}

.instagram-connection .username-input-wrapper:focus-within {
    border-color: #cc2366;
}

.instagram-connection .at-prefix {
    padding: 10px 0 10px 14px;
    color: var(--text-secondary, #888);
    font-size: 1rem;
    font-weight: 500;
    -webkit-user-select: none;
            user-select: none;
}

.instagram-connection .username-input {
    flex: 1 1;
    border: none;
    outline: none;
    padding: 10px 14px 10px 4px;
    font-size: 1rem;
    background: transparent;
    color: var(--text-primary, #1a1a1a);
}

.instagram-connection .username-input::placeholder {
    color: var(--text-tertiary, #aaa);
}

.instagram-connection .username-hint {
    margin: 6px 0 0;
    font-size: 0.82rem;
    color: var(--text-secondary, #888);
}

/* Buttons */
.instagram-connection .btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 10px 20px;
    border-radius: 8px;
    font-weight: 500;
    cursor: pointer;
    border: none;
    transition: all 0.2s;
    font-size: 0.95rem;
}

.instagram-connection .btn-primary {
    background: linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888);
    color: white;
}

.instagram-connection .btn-primary:hover {
    opacity: 0.9;
    transform: translateY(-1px);
}

.instagram-connection .btn-secondary {
    background: var(--bg-secondary, #f3f4f6);
    color: var(--text-primary, #1a1a1a);
}

.instagram-connection .btn-secondary:hover {
    background: var(--bg-tertiary, #e5e7eb);
}

.instagram-connection .btn-danger {
    background: #fee2e2;
    color: #dc2626;
}

.instagram-connection .btn-danger:hover {
    background: #fecaca;
}

.instagram-connection .btn-large {
    padding: 14px 32px;
    font-size: 1.1rem;
}

.instagram-connection .btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
}

/* Spinner */
.instagram-connection .spinner {
    width: 32px;
    height: 32px;
    border: 3px solid var(--border-color, #e5e7eb);
    border-top-color: #bc1888;
    border-radius: 50%;
    animation: instagram-spin 1s linear infinite;
}

.instagram-connection .spinner-small {
    width: 16px;
    height: 16px;
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-top-color: white;
    border-radius: 50%;
    animation: instagram-spin 1s linear infinite;
}

@keyframes instagram-spin {
    to {
        transform: rotate(360deg);
    }
}

/* Responsive */
@media (max-width: 600px) {
    .instagram-connection .section-header {
        flex-direction: column;
        text-align: center;
    }

    .instagram-connection .account-info {
        flex-direction: column;
        text-align: center;
    }

    .instagram-connection .status-badge {
        align-self: center;
    }

    .instagram-connection .account-details .stats {
        justify-content: center;
    }

    .instagram-connection .account-actions {
        flex-direction: column;
    }

    .instagram-connection .connect-prompt .requirements {
        text-align: left;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/InstagramConnection.css"],"names":[],"mappings":"AAAA;IACI,gCAAgC;IAChC,mBAAmB;IACnB,aAAa;IACb,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,SAAS;IACT,kCAAkC;AACtC;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,mCAAmC;AACvC;;AAEA;IACI,SAAS;IACT,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA,WAAW;AACX;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA,sBAAsB;AACtB;IACI,8CAA8C;IAC9C,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,+EAA+E;IAC/E,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,mCAAmC;AACvC;;AAEA;IACI,iBAAiB;IACjB,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,SAAS;IACT,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;;IAEI,SAAS;IACT,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,kDAAkD;AACtD;;AAEA,yBAAyB;AACzB;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,mCAAmC;AACvC;;AAEA;IACI,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,SAAS;IACT,kBAAkB;IAClB,kCAAkC;IAClC,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA,mBAAmB;AACnB;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,mCAAmC;IACnC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8CAA8C;IAC9C,kBAAkB;IAClB,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,aAAa;IACb,2BAA2B;IAC3B,eAAe;IACf,uBAAuB;IACvB,mCAAmC;AACvC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA,YAAY;AACZ;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,+EAA+E;IAC/E,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,wCAAwC;IACxC,mCAAmC;AACvC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;;AAEA,YAAY;AACZ;IACI,WAAW;IACX,YAAY;IACZ,8CAA8C;IAC9C,yBAAyB;IACzB,kBAAkB;IAClB,4CAA4C;AAChD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,uBAAuB;IACvB,kBAAkB;IAClB,4CAA4C;AAChD;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA,eAAe;AACf;IACI;QACI,sBAAsB;QACtB,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;QACtB,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".instagram-connection {\n    background: var(--card-bg, #fff);\n    border-radius: 12px;\n    padding: 24px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n}\n\n.instagram-connection.loading {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    min-height: 200px;\n    gap: 16px;\n    color: var(--text-secondary, #666);\n}\n\n/* Section Header */\n.instagram-connection .section-header {\n    display: flex;\n    align-items: flex-start;\n    gap: 16px;\n    margin-bottom: 24px;\n}\n\n.instagram-connection .header-icon {\n    font-size: 2.5rem;\n    line-height: 1;\n}\n\n.instagram-connection .header-text h2 {\n    margin: 0 0 8px 0;\n    font-size: 1.5rem;\n    color: var(--text-primary, #1a1a1a);\n}\n\n.instagram-connection .header-text .description {\n    margin: 0;\n    color: var(--text-secondary, #666);\n    font-size: 0.95rem;\n}\n\n/* Alerts */\n.instagram-connection .alert {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 12px 16px;\n    border-radius: 8px;\n    margin-bottom: 20px;\n}\n\n.instagram-connection .alert-success {\n    background: #dcfce7;\n    border: 1px solid #bbf7d0;\n    color: #16a34a;\n}\n\n.instagram-connection .alert-error {\n    background: #fef2f2;\n    border: 1px solid #fecaca;\n    color: #dc2626;\n}\n\n.instagram-connection .alert .dismiss {\n    margin-left: auto;\n    background: none;\n    border: none;\n    font-size: 1.2rem;\n    cursor: pointer;\n    color: inherit;\n    opacity: 0.7;\n}\n\n.instagram-connection .alert .dismiss:hover {\n    opacity: 1;\n}\n\n/* Connected Account */\n.instagram-connection .account-card {\n    border: 1px solid var(--border-color, #e5e7eb);\n    border-radius: 12px;\n    padding: 20px;\n}\n\n.instagram-connection .account-info {\n    display: flex;\n    align-items: flex-start;\n    gap: 16px;\n}\n\n.instagram-connection .profile-picture {\n    width: 80px;\n    height: 80px;\n    border-radius: 50%;\n    object-fit: cover;\n    flex-shrink: 0;\n}\n\n.instagram-connection .profile-picture.placeholder {\n    background: linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 2rem;\n}\n\n.instagram-connection .account-details {\n    flex: 1;\n    min-width: 0;\n}\n\n.instagram-connection .account-details h3 {\n    margin: 0 0 4px 0;\n    font-size: 1.2rem;\n    color: var(--text-primary, #1a1a1a);\n}\n\n.instagram-connection .account-details .display-name {\n    margin: 0 0 8px 0;\n    color: var(--text-secondary, #666);\n}\n\n.instagram-connection .account-details .stats {\n    display: flex;\n    gap: 16px;\n    margin-bottom: 8px;\n    font-size: 0.9rem;\n}\n\n.instagram-connection .account-details .stat {\n    color: var(--text-secondary, #666);\n}\n\n.instagram-connection .account-details .stat strong {\n    color: var(--text-primary, #1a1a1a);\n}\n\n.instagram-connection .account-details .connected-date,\n.instagram-connection .account-details .last-post {\n    margin: 0;\n    font-size: 0.85rem;\n    color: var(--text-tertiary, #888);\n}\n\n.instagram-connection .status-badge {\n    padding: 6px 12px;\n    border-radius: 20px;\n    font-size: 0.85rem;\n    font-weight: 500;\n    flex-shrink: 0;\n}\n\n.instagram-connection .status-badge.active {\n    background: #dcfce7;\n    color: #16a34a;\n}\n\n.instagram-connection .status-badge.inactive {\n    background: #fef3c7;\n    color: #ca8a04;\n}\n\n.instagram-connection .token-warning {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 12px;\n    background: #fef3c7;\n    border-radius: 8px;\n    margin-top: 16px;\n    color: #92400e;\n    font-size: 0.9rem;\n}\n\n.instagram-connection .account-actions {\n    display: flex;\n    gap: 12px;\n    margin-top: 20px;\n    padding-top: 20px;\n    border-top: 1px solid var(--border-color, #e5e7eb);\n}\n\n/* No Account Connected */\n.instagram-connection .no-account {\n    text-align: center;\n}\n\n.instagram-connection .connect-prompt {\n    padding: 40px 20px;\n}\n\n.instagram-connection .connect-prompt .icon {\n    font-size: 4rem;\n    margin-bottom: 16px;\n    opacity: 0.8;\n}\n\n.instagram-connection .connect-prompt h3 {\n    margin: 0 0 8px 0;\n    color: var(--text-primary, #1a1a1a);\n}\n\n.instagram-connection .connect-prompt p {\n    margin: 0 0 16px 0;\n    color: var(--text-secondary, #666);\n}\n\n.instagram-connection .connect-prompt .requirements {\n    text-align: left;\n    display: inline-block;\n    margin: 0;\n    padding-left: 24px;\n    color: var(--text-secondary, #666);\n    font-size: 0.9rem;\n}\n\n.instagram-connection .connect-prompt .requirements li {\n    margin-bottom: 8px;\n}\n\n/* Username Input */\n.instagram-connection .username-input-group {\n    max-width: 360px;\n    margin: 0 auto 24px;\n    text-align: left;\n}\n\n.instagram-connection .username-input-group label {\n    display: block;\n    font-weight: 600;\n    margin-bottom: 8px;\n    color: var(--text-primary, #1a1a1a);\n    font-size: 0.95rem;\n}\n\n.instagram-connection .username-input-wrapper {\n    display: flex;\n    align-items: center;\n    border: 2px solid var(--border-color, #d1d5db);\n    border-radius: 8px;\n    overflow: hidden;\n    transition: border-color 0.2s;\n}\n\n.instagram-connection .username-input-wrapper:focus-within {\n    border-color: #cc2366;\n}\n\n.instagram-connection .at-prefix {\n    padding: 10px 0 10px 14px;\n    color: var(--text-secondary, #888);\n    font-size: 1rem;\n    font-weight: 500;\n    user-select: none;\n}\n\n.instagram-connection .username-input {\n    flex: 1;\n    border: none;\n    outline: none;\n    padding: 10px 14px 10px 4px;\n    font-size: 1rem;\n    background: transparent;\n    color: var(--text-primary, #1a1a1a);\n}\n\n.instagram-connection .username-input::placeholder {\n    color: var(--text-tertiary, #aaa);\n}\n\n.instagram-connection .username-hint {\n    margin: 6px 0 0;\n    font-size: 0.82rem;\n    color: var(--text-secondary, #888);\n}\n\n/* Buttons */\n.instagram-connection .btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    padding: 10px 20px;\n    border-radius: 8px;\n    font-weight: 500;\n    cursor: pointer;\n    border: none;\n    transition: all 0.2s;\n    font-size: 0.95rem;\n}\n\n.instagram-connection .btn-primary {\n    background: linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888);\n    color: white;\n}\n\n.instagram-connection .btn-primary:hover {\n    opacity: 0.9;\n    transform: translateY(-1px);\n}\n\n.instagram-connection .btn-secondary {\n    background: var(--bg-secondary, #f3f4f6);\n    color: var(--text-primary, #1a1a1a);\n}\n\n.instagram-connection .btn-secondary:hover {\n    background: var(--bg-tertiary, #e5e7eb);\n}\n\n.instagram-connection .btn-danger {\n    background: #fee2e2;\n    color: #dc2626;\n}\n\n.instagram-connection .btn-danger:hover {\n    background: #fecaca;\n}\n\n.instagram-connection .btn-large {\n    padding: 14px 32px;\n    font-size: 1.1rem;\n}\n\n.instagram-connection .btn:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n    transform: none;\n}\n\n/* Spinner */\n.instagram-connection .spinner {\n    width: 32px;\n    height: 32px;\n    border: 3px solid var(--border-color, #e5e7eb);\n    border-top-color: #bc1888;\n    border-radius: 50%;\n    animation: instagram-spin 1s linear infinite;\n}\n\n.instagram-connection .spinner-small {\n    width: 16px;\n    height: 16px;\n    border: 2px solid rgba(255, 255, 255, 0.3);\n    border-top-color: white;\n    border-radius: 50%;\n    animation: instagram-spin 1s linear infinite;\n}\n\n@keyframes instagram-spin {\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n/* Responsive */\n@media (max-width: 600px) {\n    .instagram-connection .section-header {\n        flex-direction: column;\n        text-align: center;\n    }\n\n    .instagram-connection .account-info {\n        flex-direction: column;\n        text-align: center;\n    }\n\n    .instagram-connection .status-badge {\n        align-self: center;\n    }\n\n    .instagram-connection .account-details .stats {\n        justify-content: center;\n    }\n\n    .instagram-connection .account-actions {\n        flex-direction: column;\n    }\n\n    .instagram-connection .connect-prompt .requirements {\n        text-align: left;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
